import React, { createContext, useContext, useEffect, useState, useCallback, } from 'react';
import throttle from 'lodash/throttle';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useVisualViewport } from '@wix/da-ds/pkg/hooks/useVisualViewport';
export var DEFAULT_SIZE = {
    desktop: { width: 1024, height: 786 },
    mobile: { width: 375, height: 500 },
};
export var ScreenSizeContext = createContext(DEFAULT_SIZE.desktop);
ScreenSizeContext.displayName = 'ScreenSizeContext';
var THROTTLE_TIMEOUT = 500;
var THROTTLE_OPTIONS = { trailing: true };
var ScreenSizeContextProvider = function (_a) {
    var children = _a.children, prevLoadDims = _a.prevLoadDims, onUpdatedDims = _a.onUpdatedDims;
    var isMobile = useContext(MobileContext);
    var initialDims = prevLoadDims
        ? prevLoadDims
        : DEFAULT_SIZE[isMobile ? 'mobile' : 'desktop'];
    var _b = useState(initialDims), dims = _b[0], setDims = _b[1];
    var supportsVisualViewport = typeof window !== 'undefined' && window.visualViewport;
    // VisualViewport
    var updateContainerSizeFromViewport = useCallback(function (viewport) {
        var newContainer = {
            width: viewport.width,
            height: viewport.height,
        };
        if (dims !== undefined &&
            dims.width === newContainer.width &&
            dims.height === newContainer.height) {
            return;
        }
        setDims(newContainer);
        onUpdatedDims && onUpdatedDims(newContainer);
    }, [dims, onUpdatedDims]);
    useVisualViewport(updateContainerSizeFromViewport, true);
    // Fallback handling, we use resize + window.inner dimensions
    useEffect(function () {
        if (supportsVisualViewport) {
            return;
        }
        var updateContainerSize = throttle(function () {
            var newContainer = {
                width: window.innerWidth,
                height: window.innerHeight,
            };
            if (dims !== undefined &&
                dims.width === newContainer.width &&
                dims.height === newContainer.height) {
                return;
            }
            setDims(newContainer);
            onUpdatedDims && onUpdatedDims(newContainer);
        }, THROTTLE_TIMEOUT, THROTTLE_OPTIONS);
        window.addEventListener('resize', updateContainerSize);
        updateContainerSize();
        return function () {
            window.removeEventListener('resize', updateContainerSize);
        };
    }, [dims, onUpdatedDims, supportsVisualViewport]);
    return (React.createElement(ScreenSizeContext.Provider, { value: dims }, children));
};
ScreenSizeContextProvider.displayName = 'ScreenSizeContextProvider';
export default ScreenSizeContextProvider;
//# sourceMappingURL=ScreenSizeContext.js.map